//import imagesLoaded from "imagesloaded";
import gsap from "gsap";
import Swiper, { Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
Swiper.use([Navigation, Pagination]);

/**
 *  {{ productImages: any[]; productVariants: any; variantsMetafieldsData: string; variantToShowFirst: string; selectedVariantTitle: string; }}
 */
export default ({
  productImages,
  productVariants,
  variantsMetafieldsData,
  selectedVariantTitle,
  variantToShowFirst,
}) => ({
  activeVariant: {
    title: "",
    id: "",
    modelInfo: "",
  },
  imagePickerVisible: false,
  swiper: null,
  productVariantsData: {
    XS: {
      title: "XS",
      modelInfo: "",
      images: [],
    },
    S: {
      title: "S",
      modelInfo: "",
      images: [],
    },
    M: {
      title: "M",
      modelInfo: "",
      images: [],
    },
    L: {
      title: "L",
      modelInfo: "",
      images: [],
    },
    XL: {
      title: "XL",
      modelInfo: "",
      images: [],
    },
    XXL: {
      title: "XXL",
      modelInfo: "",
      images: [],
    },
    default: {
      title: "default",
      modelInfo: "",
      images: [],
    },
  },
  init() {
    this.getVariantImages(productImages);
    this.getVariantModelInfo(variantsMetafieldsData);
    this.setInitialVariant(selectedVariantTitle, variantToShowFirst);

    this.manageSwiper();

    fadeInImages(this.$root, `#variant-images-${this.activeVariant.id}`);
  },
  initSwiper() {
    // init swiper for the active container?..å
    if (window.innerWidth < 768) {
      this.swiper = new Swiper(`#variant-images-${this.activeVariant.id}`, {
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    }
  },
  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  },
  manageSwiper() {
    if (window.innerWidth < 768) {
      if (this.swiper) {
        return;
      } else {
        this.initSwiper();
      }
    } else {
      this.destroySwiper();
      /* if (this.swiper) {
        console.log("this swiper");
        this.swiper.destroy();
        this.swiper = null;
      } */
    }
  },
  /**
   *
   * @param {Array} productImages
   */
  getVariantImages(productImages = []) {
    if (productImages.length != 0) {
      for (let i = 0; i < productImages.length; i++) {
        const startSlice = productImages[i].lastIndexOf("/");
        const imageFilename = productImages[i].slice(startSlice + 1, -1);
        const prefix = imageFilename.split("_")[0];
        if (["XS", "S", "M", "L", "XL", "XXL"].includes(prefix)) {
          this.productVariantsData[prefix].images.push(productImages[i]);
        } else {
          this.productVariantsData.default.images.push(productImages[i]);
        }
      }
    }
  },
  /**
   *
   * @param {String} metafieldsData
   */
  getVariantModelInfo(metafieldsData) {
    let str = metafieldsData;
    // Strip last comma
    if (str[str.length - 1] == ",") {
      str = str.slice(0, -1);
    }
    let arr = str.split(",");
    if (arr.length != 0) {
      for (let i = 0; i < arr.length; i++) {
        const prefix = arr[i].split("_")[0];
        if (["XS", "S", "M", "L", "XL", "XXL"].includes(prefix)) {
          this.productVariantsData[prefix].modelInfo = arr[i].split("_")[1];
        }
      }
    }
  },
  togglePicker() {
    this.imagePickerVisible = !this.imagePickerVisible;
  },
  /**
   *
   * @param {String} selectedVariantTitle
   * @param {String} variantToShowFirst
   */
  setInitialVariant(selectedVariantTitle, variantToShowFirst) {
    if (
      this.productVariantsData[selectedVariantTitle] &&
      this.productVariantsData[selectedVariantTitle].images.length
    ) {
      //console.log("The url has a variant and it has images");
      this.activeVariant = {
        title: selectedVariantTitle,
        id: this.getVariantIdByTitle(selectedVariantTitle),
        modelInfo: this.productVariantsData[selectedVariantTitle].modelInfo,
      };
    } else {
      if (
        this.productVariantsData[variantToShowFirst] &&
        this.productVariantsData[variantToShowFirst].images.length
      ) {
        //console.log(
        //  "No images for this variant but the variantToShowFirst is available"
        //);
        this.activeVariant = {
          title: variantToShowFirst,
          id: this.getVariantIdByTitle(variantToShowFirst),
          modelInfo: this.productVariantsData[variantToShowFirst].modelInfo,
        };
      } else {
        //console.log("only default or some other variant images are available");
        // find first variant with images and show it

        const firstVariantWithImages = Object.values(
          this.productVariantsData
        ).filter((obj) => obj.images.length !== 0)[0];
        // will be default if all sizes are empty
        if (firstVariantWithImages) {
          this.activeVariant = {
            title: firstVariantWithImages.title,
            id: this.getVariantIdByTitle(firstVariantWithImages.title),
            modelInfo: this.productVariantsData[firstVariantWithImages.title]
              .modelInfo,
          };
        }
      }
    }
  },
  /**
   *
   * @param {String} variantTitle
   */
  setActiveVariant(variantTitle) {
    window.scrollTo({ top: 0, behavior: "smooth" });
    this.activeVariant = {
      title: variantTitle,
      id: this.getVariantIdByTitle(variantTitle),
      modelInfo: this.productVariantsData[variantTitle].modelInfo,
    };
    this.imagePickerVisible = false;

    this.destroySwiper();
    this.initSwiper();
    // TODO
    fadeInImages(
      this.$root,
      `#variant-images-${this.getVariantIdByTitle(variantTitle)}`
    );
  },
  /**
   *
   * @param {String} variantId
   * @returns
   */
  getVariantById(variantId) {
    return productVariants.find((variant) => variant.id == variantId);
  },
  /**
   *
   * @param {String} variantTitle
   * @returns
   */
  getVariantIdByTitle(variantTitle) {
    if (variantTitle == "default") {
      return "default";
    } else {
      var variantForId = productVariants.find((variant) => variant.title == variantTitle);
      if (variantForId) {
        return variantForId.id;
      } else {
        return "default";
      }
    }
  },
});

/**
 *
 * @param {HTMLElement} baseElement
 * @param {string} selectorString
 * @returns
 */
function fadeInImages(baseElement, selectorString) {
  const currentVariantContainer = baseElement.querySelector(selectorString);
  if (!currentVariantContainer) return;
  const currentVariantImages = currentVariantContainer.querySelectorAll("img");
  if (!currentVariantImages.length) return;

  for (let i = 0; i < currentVariantImages.length; i++) {
    let img = currentVariantImages[i];

    img.style.opacity = "0";

    /* if img.complete == true then setting style.opacity = "1.0" would work BUT the transition would not fire,
    using gsap fixes this problem */
    if (img.complete) {
      img.style.opacity = "0";
      gsap.to(img, {
        opacity: 1,
      });
    } else {
      img.onload = function() {
        gsap.to(img, {
          opacity: 1,
        });
      };
    }
  }
}
